import { assertEvent, stopChild } from 'xstate5';

import { type BundleMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Stops the customization machine of a product removed from the bundle.
 */
export const stopProductCustomization: BundleMachineAction = stopChild((args) => {
  const { event } = args;

  assertEvent(event, 'REMOVE_SELECTED');

  return event.selectionId;
});
